// hooks/usePrompt.ts
import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export const usePrompt = (when, message) => {
  const navigator = useContext(NavigationContext).navigator;

  useEffect(() => {
    if (!when) return;

    const unblock = navigator.block((tx) => {
      if (window.confirm(message)) {
        unblock(); // Unblock so it doesn’t loop
        tx.retry(); // Retry the transition
      }
      // else: stay on current page
    });

    return unblock;
  }, [navigator, when, message]);
};
